const NATURE = "https://images.unsplash.com/photo-1446038236174-69712e24d137?crop=entropy&cs=srgb&fm=jpg&q=85";
const COAST = "https://images.unsplash.com/photo-1446038202205-1c96430dbdab?crop=entropy&cs=srgb&fm=jpg&q=85";
const ADVENTURE = "https://images.unsplash.com/photo-1489914169085-9b54fdd8f2a2?crop=entropy&cs=srgb&fm=jpg&q=85";
const STUDIO = "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?crop=entropy&cs=srgb&fm=jpg&q=85";
const DIGITAL = "https://images.unsplash.com/photo-1632582204758-5ac65783517a?crop=entropy&cs=srgb&fm=jpg&q=85";
const PEOPLE = "https://images.unsplash.com/photo-1697490251788-21888514f669?crop=entropy&cs=srgb&fm=jpg&q=85";
const HANDS = "https://images.unsplash.com/photo-1556484687-30636164638b?crop=entropy&cs=srgb&fm=jpg&q=85";

export const WORLD_PORTALS = [
  { key: "Adventure", image: ADVENTURE, pull: ["EXPLORE", "EXPERIENCE"], x: 8, y: 17, size: 150 },
  { key: "Creation", image: STUDIO, pull: ["CREATE", "MAKE"], x: 31, y: 8, size: 130 },
  { key: "Knowledge", image: DIGITAL, pull: ["LEARN", "UNDERSTAND"], x: 58, y: 12, size: 120 },
  { key: "People", image: PEOPLE, pull: ["CONNECT", "BELONG"], x: 78, y: 17, size: 145 },
  { key: "Nature", image: NATURE, pull: ["EXPLORE", "EXPERIENCE"], x: 17, y: 49, size: 120 },
  { key: "Culture", image: HANDS, pull: ["CONNECT", "UNDERSTAND"], x: 42, y: 39, size: 155 },
  { key: "Building", image: DIGITAL, pull: ["BUILD", "MAKE"], x: 72, y: 46, size: 112 },
  { key: "Wellness", image: COAST, pull: ["EXPERIENCE", "UNDERSTAND"], x: 88, y: 52, size: 105 },
  { key: "Impact", image: HANDS, pull: ["HELP", "LEAD"], x: 5, y: 74, size: 116 },
  { key: "Freedom", image: COAST, pull: ["EXPLORE", "EXPRESS"], x: 27, y: 72, size: 135 },
  { key: "Mastery", image: STUDIO, pull: ["LEARN", "MAKE"], x: 52, y: 70, size: 108 },
  { key: "Expression", image: STUDIO, pull: ["EXPRESS", "CREATE"], x: 67, y: 77, size: 126 },
  { key: "Discovery", image: NATURE, pull: ["EXPLORE", "UNDERSTAND"], x: 84, y: 78, size: 138 },
  { key: "Belonging", image: PEOPLE, pull: ["BELONG", "CONNECT"], x: 47, y: 88, size: 105 },
];

export const PULL_CONCEPTS = ["MAKE", "EXPLORE", "CONNECT", "LEARN", "CREATE", "HELP", "BUILD", "EXPERIENCE", "UNDERSTAND", "EXPRESS", "BELONG", "LEAD"];
export const PRIORITIES = ["Freedom", "Mastery", "Connection", "Recognition", "Security", "Adventure", "Impact", "Creativity", "Knowledge", "Wealth", "Peace", "Contribution"];

export const PEOPLE_NODES = [
  ["Someone who knows what I don't", "learning", 1],
  ["Someone I can teach", "teaching", 2],
  ["Someone to create with", "collaboration", 3],
  ["Someone to explore with", "exploration", 4],
  ["Someone who challenges me", "growth", 5],
  ["Someone who inspires me", "mentorship", 6],
  ["Someone who needs my help", "service", 7],
  ["Someone with the same obsession", "belonging", 8],
  ["Someone completely different", "discovery", 2],
];

export const FUTURE_FRAGMENTS = [
  ["Unvisited world", "passport", "Adventure", "Explore"],
  ["Unplayed stage", "guitar", "Expression", "Create"],
  ["Waiting community", "people", "Belonging", "Connect"],
  ["Unbuilt idea", "idea", "Building", "Build"],
  ["Unwritten knowledge", "book", "Knowledge", "Learn"],
  ["Unfinished canvas", "brush", "Creation", "Express"],
];

export const seedPullsFromWorlds = (worlds) => {
  const scores = Object.fromEntries(PULL_CONCEPTS.map((item) => [item, 0.08]));
  worlds.forEach(({ key, weight }) => {
    const portal = WORLD_PORTALS.find((item) => item.key === key);
    portal?.pull.forEach((pull) => { scores[pull] += weight * .45; });
  });
  return scores;
};